import request from '@/axios'


// 获取人员列表
export function getCustomerList(data={}) {
    return request({
        url: '/customerUser/list',
        method: 'get',
        params: data
    })
}

// 修改用户结余时间
export function updatePoints(data={}) {
    return request({
        url: '/customerUser/updatePoints',
        method: 'post',
        params: data
    })
}

// 测试推送消息
export function testPushMessage(data={}) {
    return request({
        url: '/test/push',
        method: 'post',
        params: data
    })
}

// 用户结余时间明细
export function getPointsDetailList(data={}) {
    return request({
        url: '/pointsDetail/list',
        method: 'get',
        params: data
    })
}

